import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-content-header-cabinet',
    templateUrl: './content-header.component.html',
    styleUrl: './content-header.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom
})
export class ContentHeaderCabinetComponent {

}
